/* @flow */

import type { NETGEM_FUTURE_RECORDINGS_STATUS } from '../../../libs/netgemLibrary/v8/types/Npvr';

import { formatDuration } from '../../../helpers/dateTime/Format';

const getNpvrTotalQuota = (status: ?NETGEM_FUTURE_RECORDINGS_STATUS): string | null => {
  if (!status) {
    return null;
  }

  const {
    maxQuota: { duration },
  } = status;

  return formatDuration(duration).display;
};

export { getNpvrTotalQuota };
